<div class="grid gap-x-10 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,1fr)]">
  <!-- Durchsatz -->
  <section class="pt-8 min-w-0">
    <div class="flex flex-wrap items-center gap-3 pb-3">
      <h2 class="text-base font-bold tracking-[-0.01em] text-foreground">Durchsatz</h2>
      <span class="font-mono text-2xs text-muted-foreground">30 Tage</span>
      <div class="ml-auto flex items-center gap-3.5">
        @for (entry of timelineLegend; track entry.label) {
          <span class="flex items-center gap-1.5 font-mono text-2xs text-muted-foreground">
            <span class="w-2 h-2 rounded-full" [style.background-color]="entry.color"></span>
            {{ entry.label }}
          </span>
        }
      </div>
    </div>

    <div class="border-t border-border pt-2">
      @if (isLoading()) {
        <div class="h-[220px] rounded-md bg-muted animate-pulse"></div>
      } @else if (loadError()) {
        <p class="py-4 text-sm text-muted-foreground">Auswertung konnte nicht geladen werden.</p>
      } @else {
        @if (timelineOptions(); as opts) {
        <apx-chart
          [series]="opts.series"
          [chart]="opts.chart"
          [xaxis]="opts.xaxis"
          [yaxis]="opts.yaxis"
          [stroke]="opts.stroke"
          [fill]="opts.fill"
          [tooltip]="opts.tooltip"
          [legend]="opts.legend"
          [dataLabels]="opts.dataLabels"
          [grid]="opts.grid"
          [colors]="opts.colors"
        />
        }
      }
    </div>
  </section>

  <!-- Vertriebsstatus -->
  <section class="pt-8 min-w-0">
    <div class="flex flex-wrap items-baseline gap-2.5 pb-3">
      <h2 class="text-base font-bold tracking-[-0.01em] text-foreground">Vertriebsstatus</h2>
      <span class="ml-auto font-mono text-2xs text-muted-foreground">{{ statusTotal() }} gesamt</span>
    </div>

    <div class="border-t border-border pt-1.5">
      @if (isLoading()) {
        @for (i of [1, 2, 3, 4, 5]; track i) {
          <div class="py-[7px] flex flex-col gap-1.5">
            <div class="h-3 w-1/3 rounded bg-muted animate-pulse"></div>
            <div class="h-[5px] w-full rounded-full bg-muted animate-pulse"></div>
          </div>
        }
      } @else {
        @for (row of funnelRows(); track row.label; let last = $last) {
          <div class="py-[7px]">
            <div class="flex items-baseline gap-2 mb-1.5">
              <span class="text-dense text-foreground">{{ row.label }}</span>
              <span class="ml-auto font-mono text-xs text-foreground">{{ row.count }}</span>
              <span class="w-9 text-right font-mono text-2xs text-muted-foreground">{{ row.share }}</span>
            </div>
            <div class="h-[5px] flex gap-px rounded-full bg-muted overflow-hidden">
              @for (segment of row.segments; track $index) {
                <span
                  class="h-full"
                  [style.width.%]="segment.percent"
                  [style.background-color]="segment.color"
                ></span>
              }
            </div>

            <!-- Only the combined final row needs telling apart. -->
            @if (last) {
              <div class="flex items-center gap-3.5 flex-wrap mt-2">
                @for (entry of finalStatusLegend; track entry.label) {
                  <span class="flex items-center gap-1.5 font-mono text-2xs text-muted-foreground">
                    <span class="w-2 h-2 rounded-full" [style.background-color]="entry.color"></span>
                    {{ entry.label }}
                  </span>
                }
              </div>
            }
          </div>
        }
      }
    </div>
  </section>
</div>
